import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";


export function NgxMultiNameFunc(multiNameFunc: MultiNameFunc): OperatorFunction<Multi[], Multi[]> {

 

  return map(multis => {
    const newMultis = multis.map((multi, index) => {
      const newMulti: Multi = Object.assign({}, multi, { name: multiNameFunc(multi, index, multis) });
      return newMulti;
    });

    return newMultis;
  });
}



interface MultiNameFunc {
  (multi: Multi, index: number, array: Multi[]): String;
}
